import clsx from "clsx";
import React from "react";
import classes from "./AppButton.module.scss";

export const AppButton = ({ className, text, textWeight, textSize, isLoading, ...props }) => {
	return (
		<button
			className={clsx(classes.button, className)}
			style={{
				fontWeight: textWeight,
				fontSize: textSize,
				display: "flex",
			}}
			disabled={isLoading}
			{...props}
		>
			{isLoading ? <div className={classes["lds-dual-ring"]}></div> : text}
		</button>
	);
};
